class ScrollTo {
	constructor(scrollBtn) {
		this.scrollBtn = scrollBtn;
	}
	scrollDown(e) {
		const target = e.currentTarget;
		const parent = target.parentNode;
		const grandparent = parent.parentNode;
		const startTime = new Date().getTime();
		const currentScroll = window.pageYOffset;
		let wrapper = null;
		if (parent.tagName === "SECTION") {
			wrapper = parent;
		} else if (grandparent.tagName === "SECTION") {
			wrapper = grandparent;
		}

		if (wrapper) {
			const nextSection = wrapper.nextElementSibling;
			const distanceToScroll = nextSection.offsetTop;

			if (distanceToScroll > currentScroll) {
				requestAnimationFrame(scroll);
			} else {
				return;
			}

			function scroll() {
				const duration = 500;
				const now = new Date().getTime();
				const time = Math.min(1, (now - startTime) / duration);
				window.scroll(
					0,
					Math.ceil(
						time * (distanceToScroll - currentScroll) +
						currentScroll
					)
				);

				if (window.pageYOffset < distanceToScroll) {
					requestAnimationFrame(scroll);
				}
			}
		}
	}

	init() {
		let scrollBtn = document.querySelectorAll(this.scrollBtn);
		if (scrollBtn) {
			scrollBtn = Array.prototype.slice.call(scrollBtn);
			scrollBtn.forEach(element => {
				element.addEventListener("click", e => this.scrollDown(e));
			});
		}
	}
}

export default new ScrollTo(".scroll-down");
